module.exports = __webpack_public_path__ + "img/meeting.ce80c7ea.svg";